module.exports = __webpack_public_path__ + "img/btn_phone.f9465523.png";